import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=dcae65ca&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AccountDetails.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=dcae65ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcae65ca",
  null
  
)

export default component.exports